"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.any = exports.any_io = void 0;
var React = __importStar(require("react"));
var widget_1 = require("../basics/widget");
var options_1 = require("../basics/options");
/**
 * @deprecated Don't use directly, use the [[any]] function instead.
 * @todo maybe change it to `React.FunctionComponent` and hooks, since currently it has not state.
 */
var Any = /** @class */ (function (_super) {
    __extends(Any, _super);
    function Any(props, context) {
        return _super.call(this, props, context) || this;
    }
    Any.prototype.render = function () {
        var _this = this;
        return React.createElement(React.Fragment, null, this.props.widgets.map(function (widget) {
            return widget(_this.props.input).run(function (output) { return _this.props.on_done(output); });
        }));
    };
    return Any;
}(React.Component));
/**
 * This is the lifted functorial version of [[any]]
 * This means instead of operating on array of widgets, it operates on array of iowidgets
 */
var any_io = function (options) {
    return function (widgets) { return function (input) { return (0, widget_1.fromJSX)(function (on_done) {
        return React.createElement(Any, { options: options, on_done: on_done, widgets: widgets, input: input, key: (0, options_1.option)("key", options) });
    }); }; };
};
exports.any_io = any_io;
/**
 * Takes as input an array of widgets and propagates the result of
 * the first one that fires.
 * NOTE: All inputted widgets must have the same output type. In case,
 * a widget does not have a compatible type, you can use [[map]] to turn
 * its output type to a compatible one of `o`. A particularly easy to use
 * behaviour is to use [[never]] instead of mapping it.
 * @typeparam o the result type of any
 */
var any = function (widgets, options) {
    return (0, exports.any_io)(options)(widgets.map(function (w) { return function (_) { return w; }; }))({});
};
exports.any = any;
